import React from 'react';
import styles from 'components/TabBar/TabBar.module.scss';
type PinProps = {
  style?: any,
  onClick?: any
}
const Pin: React.FC<PinProps> = (props: PinProps) => {
  return(
<div onClick={props.onClick}>
  <svg className={props.style} xmlns="http://www.w3.org/2000/svg" width="21.574" height="21.574" viewBox="0 0 21.574 21.574">
    <g id="Group_536" data-name="Group 536" transform="translate(0.707 0.707)">
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 10.08) rotate(-45)">
        <g id="Layer_1" data-name="Layer 1" transform="translate(0 0)">
          <path id="Path_821" d="M7.128,0A7.128,7.128,0,0,0,0,7.128c0,.019,0,.037,0,.057v7.071H7.128A7.128,7.128,0,1,0,7.128,0Z" fill="none" stroke="#939393" strokeLinecap="round" strokeWidth="1"/>
        </g>
      </g>
      <ellipse id="Ellipse_617" cx="1.75" cy="1.75" rx="1.75" ry="1.75" transform="translate(8.33 8.476)" fill="none" stroke="#939393" strokeWidth="1"/>
    </g>
  </svg>
  </div>
  )
}
export default Pin;